import { Breadcrumbs, Link, TablePagination, Typography } from "@mui/material";
import { Link as LinkTo } from 'react-router';
import { ObrasTopHeader } from "../../components/obras_top_header";
import { useObrasTreinamentoViewModel } from "../../viewModels/obras_treinamentos_view_model";
import { useMemo } from "react";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { GenerateObraEstruturaTreinamentoColumns } from "./columns/obra_estrutura_treinamento";
import { EstTreinamentoModal } from "./columns/components/est_treinamento_modal";
import { PlanoTreinamentoLista } from "../../../domain/models/plano_treinamento_lista";
import { ObrasTopBar } from "../../components/obras_top_bar";
import { ObrasReportModals } from "../../components/obras_report_modals";

import DeleteDialog from "../../../../../common/components/delete_dialog";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";

export const ObrasTreinamento = () => {
  const viewModel = useObrasTreinamentoViewModel();

  const obraEstruturaTreinamentoColumns = useMemo(() => {
    return GenerateObraEstruturaTreinamentoColumns({
      onActionEditar: viewModel.handleCadastroPlanoTreiOpenState,
      onActionDeletar: viewModel.handleDeleteOPlanoTreinamentoModalOpenState,
    });
  }, [viewModel.handleCadastroPlanoTreiOpenState, viewModel.handleDeleteOPlanoTreinamentoModalOpenState]);

  return (
    <>
      <ObrasTopBar
        obrasReportState={viewModel.obrasReportState}
        state={viewModel.obrasTopHeaderState}
        selectedObra={viewModel.selectedObra}
        onBack={viewModel.handleBack}
        leftBackSlotButton={
          <div className="w-[8rem]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
              onMouseDown={e => {
                viewModel.handleCadastroPlanoTreiOpenState(null, true)
                e.preventDefault();
              }}>
              Novo Item
            </PrimaryButton>
          </div>
        }
      />
      <form>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Obras
            </Link>
            <Link underline="hover" color="inherit">
              Lista de Obras
            </Link>
            <Typography className="text-primary-green" component={'span'}>
              <LinkTo to='/Obras_lista'>  Plano de Treinamento </LinkTo>
            </Typography>
          </Breadcrumbs>
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <ObrasTopHeader
              title='Plano de Treinamento'
              selectedObra={viewModel.selectedObra}
              onReload={viewModel.handleReload}
            />
          </div>

          <StyledDataGrid
            tableName="obras_treinamentos"
            disableColumnMenu={false}
            getRowId={(row: PlanoTreinamentoLista) => row.IdPlanoTreinamento}
            getRowHeight={() => 'auto'}
            columns={obraEstruturaTreinamentoColumns}
            loading={viewModel.loading}
            rows={viewModel.planoTreinamentoLista}
            rowCount={viewModel.pagination.totalItems}
            pageSizeOptions={[10]}
            paginationMode="server"
            paginationModel={{
              page: viewModel.pagination.page,
              pageSize: viewModel.pagination.rowsPerPage,
            }}
          />

          <TablePagination
            component="div"
            count={viewModel.pagination.totalItems}
            page={viewModel.pagination.page - 1}
            onPageChange={(_, p) => viewModel.handlePageChange(p)}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowsPerPage={viewModel.pagination.rowsPerPage}
            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
          />
        </div>
      </form>

      {/* Modal */}
      <EstTreinamentoModal
        open={viewModel.planoTreinModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectedPlanoTreinamento={viewModel.selectedPlanoTreinamento}
        onClose={() => viewModel.handleCadastroPlanoTreiOpenState(null, false)}
        onSubmit={viewModel.handlePlanoTreinamentoSubmit} />

      <ObrasReportModals
        state={viewModel.obrasReportState}
      />

      <DeleteDialog
        open={viewModel.planoTreinamentoDeleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteOPlanoTreinamentoModalOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmaPlanoTreinamento} />

    </>
  )
};
